module.exports = __webpack_public_path__ + "./assets/img_jiaoxi_grey__02b1c94f4ccbc5ea0167304e5a6426e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/home/img_jiaoxi_grey.jpg
// module id = 617
// module chunks = 12